import ApplicationSerializer from 'lumen/serializers/application';

export default class CostSettingCostSerializer extends ApplicationSerializer {
  attrs = {
    // Costs are written nested inside their profile.
    profile: { serialize: false },
  };
}
